/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CouponCodeDto { 
    id?: number;
    uuid?: string;
    code?: string;
    status?: CouponCodeDto.StatusEnum;
    created?: string;
    assignedAt?: string;
}
export namespace CouponCodeDto {
    export type StatusEnum = 'AVAILABLE' | 'ASSIGNED';
    export const StatusEnum = {
        Available: 'AVAILABLE' as StatusEnum,
        Assigned: 'ASSIGNED' as StatusEnum
    };
}


